import _ from "lodash";
import ODataFilterFactory from "common/services/oDataService/odata_filter_factory.class";
import validator from "./validation_helpers";

export default function (
    $sbCurrentProject,
    $sbDeliverableJobsApi,
    $q,
    $sbJobApi
) {
    "ngInject";

    /////////////////////
    //
    //      API
    //
    /////////////////////

    var service = {
        forDeliverables: reassociateForDeliverables,
    };

    return service;

    /////////////////////
    //
    //      IMPL
    //
    /////////////////////

    function reassociateForDeliverables(
        processTemplateId,
        deliverables,
        isForceOverwrite = false
    ) {
        if (!_.isArray(deliverables) && !_.isString(deliverables)) {
            throw new Error(
                "Invalid parameter. Wrong type for parameter 'deliverables'"
            );
        }

        if (_.isArray(deliverables)) {
            validator.throwOnMissingKeys(deliverables, [
                "ID",
                "PI_TEMPLATE_ID",
            ]);

            deliverables = _filterForApplicableDeliverables(
                processTemplateId,
                deliverables
            );

            if (_.isEmpty(deliverables)) {
                return $q.resolve({});
            }
        }

        if (_.isString(deliverables)) {
            deliverables = _extendQueryToMatchOnlyApplicableDeliverables(
                processTemplateId,
                deliverables
            );
        }

        return $sbDeliverableJobsApi
            .createAssignProcessJob($sbCurrentProject.pick("id"), {
                strategy: isForceOverwrite
                    ? $sbDeliverableJobsApi.ASSIGN_STRATEGY.OVERWRITE
                    : $sbDeliverableJobsApi.ASSIGN_STRATEGY.SAFE_OVERWRITE,
                deliverable_set: deliverables,
                process_template_id: processTemplateId,
            })
            .then(({ response, jobId }) => {
                if (jobId) {
                    // Wait until the job is done
                    return $sbJobApi.waitFor(jobId).then(() => response);
                }
                return response;
            });
    }

    /**
     *
     * Filter for all deliverables which have a different process template associated to them.
     * Return the list of deliverable Ids (UUID).
     *
     * @param {string} processTemplateId - UUID
     *
     * @param {Object[]} deliverables
     * @param {String} deliverables.ID - UUID
     * @param {String} deliverables.PI_TEMPLATE_ID - UUID
     *
     * @returns {string[]}
     * @private
     */
    function _filterForApplicableDeliverables(processTemplateId, deliverables) {
        return (deliverables || [])
            .filter(function (deliverable) {
                return (
                    deliverable.PI_TEMPLATE_ID !== null &&
                    deliverable.PI_TEMPLATE_ID !== processTemplateId
                );
            })
            .map(function (deliverable) {
                return deliverable.ID;
            });
    }

    function _extendQueryToMatchOnlyApplicableDeliverables(
        processTemplateId,
        queryString
    ) {
        var differentAssociatedProcessTemplateFilter = new ODataFilterFactory()
            .and()
            .block(
                new ODataFilterFactory()
                    .ne("TEMPLATE_ID", null)
                    .and()
                    .ne("TEMPLATE_ID", processTemplateId)
            );

        return (
            queryString + " " + differentAssociatedProcessTemplateFilter.get()
        );
    }
}
